import { ValidatorWithInfo } from '@block-explorer/entities';
import { compareValidatorsByPriority } from '../utils/sorting';

export const sortByVerifiedValidators = (
  validators: ValidatorWithInfo[],
  sortingKey: string
) => {
  // double sorting is needed for adding rank for each validator,
  // before apply sorting by `isVerifiedValidator`
  return validators.sort((a, b) =>
    compareValidatorsByPriority(a, b, 'isVerifiedValidator', sortingKey)
  );
};
